import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { ChartComponent } from "./chart/chart";
import { KpichartComponent } from "./kpichart/kpichart";
import { IonicModule } from "ionic-angular";
import { CustomLoadingComponent } from "./custom-loading/custom-loading";
import { PipesModule } from "../pipes/pipes.module";
import { AgendaComponent } from "./agenda/agenda";
import { KpiComponent } from "./kpi/kpi";
import { NoDataComponent } from "./no-data/no-data";
import { TimeControlComponent } from "./time-control/time-control";
import { TimecontrolToolbarComponent } from "./timecontrol-toolbar/timecontrol-toolbar";
import { KpiCardComponent } from "./kpi-card/kpi-card";
import { CustomerHierachyItemComponent } from "./customer-hierachy-item/customer-hierachy-item";
import { DirectivesModule } from "../directives/directives.module";
import { InstrumentHealthOverviewComponent } from "./instrument-health-overview/instrument-health-overview";
import { InstrumentHealthPage } from "../pages/instrument-health/instrument-health";
import { DeviationCardComponent } from "./deviation-card/deviation-card";
import { TrainInstrumentHealthComponent } from "./train-instrument-health/train-instrument-health";
import { PdfViewerComponent } from "./pdf-viewer/pdf-viewer";
import { TrendExplorerComponent } from "./trend-explorer/trend-explorer.component";
import { PerformanceGaugeComponent } from "./performance-gauge/performance-gauge";
import { PerformanceDetailsComponent } from "./performance-details/performance-details";
import { TimePickerComponent } from "./time-picker/time-picker";
import { TagsFilterComponent } from "./trend-explorer/tags-filter/tags-filter.component";
import { LegendTagsPipe } from "./trend-explorer/legend-tags.pipe";
import { TrainStatusComponent } from "./train-status/train-status";
import { TrendExplorerTagListComponent } from "./trend-explorer-tag-list/trend-explorer-tag-list";

@NgModule({
  declarations: [
    PerformanceDetailsComponent,
    ChartComponent,
    KpichartComponent,
    CustomLoadingComponent,
    AgendaComponent,
    KpiComponent,
    NoDataComponent,
    TimeControlComponent,
    TimecontrolToolbarComponent,
    KpiCardComponent,
    CustomerHierachyItemComponent,
    InstrumentHealthOverviewComponent,
    InstrumentHealthPage,
    DeviationCardComponent,
    TrainInstrumentHealthComponent,
    PdfViewerComponent,
    TrendExplorerComponent,
    PerformanceGaugeComponent,
    PerformanceDetailsComponent,
    TimePickerComponent,
    TagsFilterComponent,
    LegendTagsPipe,
    TrainStatusComponent,
    TrendExplorerTagListComponent,
  ],
  imports: [IonicModule, PipesModule, DirectivesModule],
  exports: [
    PerformanceDetailsComponent,
    ChartComponent,
    KpichartComponent,
    CustomLoadingComponent,
    AgendaComponent,
    KpiComponent,
    NoDataComponent,
    TimeControlComponent,
    TimecontrolToolbarComponent,
    KpiCardComponent,
    CustomerHierachyItemComponent,
    InstrumentHealthOverviewComponent,
    DeviationCardComponent,
    PdfViewerComponent,
    TrendExplorerComponent,
    PerformanceGaugeComponent,
    PerformanceDetailsComponent,
    TimePickerComponent,
    TagsFilterComponent,
    LegendTagsPipe,
    TrainStatusComponent,
    TrendExplorerTagListComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [
    PerformanceDetailsComponent,
    TimeControlComponent,
    InstrumentHealthPage,
    PdfViewerComponent,
    TrendExplorerTagListComponent,
  ],
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts